import { render, staticRenderFns } from "./SystemParametersConfig.vue?vue&type=template&id=1d31915c"
import script from "./SystemParametersConfig.vue?vue&type=script&lang=js"
export * from "./SystemParametersConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports